"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTeamNamePlugin = void 0;
const createTeamNamePlugin = (teamName) => {
    validateTeamName(teamName);
    const transform = (ctx) => {
        var _a, _b, _c;
        try {
            const team = (_c = (_b = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.team) !== null && _c !== void 0 ? _c : teamName;
            ctx.updateEvent('context.team', team);
        }
        catch (e) {
            console.log(e);
        }
        return ctx;
    };
    return {
        name: 'Team Name',
        type: 'enrichment',
        version: '1.0.0',
        isLoaded: () => true,
        load: () => Promise.resolve(),
        track: transform,
        page: transform,
        identify: transform,
    };
};
exports.createTeamNamePlugin = createTeamNamePlugin;
function validateTeamName(teamName) {
    if (teamName.length < 1 || teamName.length > 100) {
        throw new Error(`invalid team name size: ${teamName}`);
    }
}
//# sourceMappingURL=teamName.js.map